import classnames from 'classnames'
import React from 'react'
// Utils

import { TrackConfig } from '../../../hocs/withTracking'
import { Button, ButtonProps } from '../../button'
import ReviewStars from '../reviewStars'

import styles from './noReviews.module.scss'

export interface NoReviewsProps {
  noReviewTitle?: string
  writeReviewButton: ButtonProps
  trackConfig?: TrackConfig
  message?: string
  className?: string
  hideWriteReviewButton?: boolean
  openCreateReviewPopUp: () => void
}

export const NoReviews = ({
  className = '',
  message = '',
  noReviewTitle = 'No reviews yet',
  ...props
}: NoReviewsProps) => {
  const wrapClasses = classnames(styles.noReviewsWrap, 'font-line-height--2', className)

  return (
    <div className={wrapClasses}>
      <ReviewStars totalStars={5} fillStars={0} className={styles.noReviewsWrap__ratingContainer} />
      <div className={classnames(styles.noReviewsWrap__title)}>{noReviewTitle}</div>
      <div className={classnames('font-case--upper', styles.noReviewsWrap__reivewsTitle)}>0 reviews</div>
      {!props.hideWriteReviewButton && (
        <Button
          {...props.writeReviewButton}
          trackConfig={props.trackConfig}
          onClick={props.openCreateReviewPopUp}
          className={styles.reviewButton}
        />
      )}
      {message && !props.hideWriteReviewButton && (
        <div className={classnames(styles.noReviewsWrap__message)}>{message}</div>
      )}
    </div>
  )
}

export default NoReviews
